export default __webpack_public_path__ + "locales/sl/Payments.json?hash=b07b716026427c1f1bb47ff4f6e60b2a";